import React, { useEffect } from 'react';
import {
  Box,
  Typography,
  Select,
  Pagination,
  MenuItem,
  Stack
} from "@mui/material";
import dayjs from "dayjs";
import { useSelector } from 'react-redux';
import NoDataFound from '../../../common/NoDataFound';
import NoSearchResults from '../../../common/helpers/NoSearchResults';
 
const CustomerSearchResultList = (props) => {
  const {
    clientCustomerId,
    get_customer_list,
    handleRowClick,
    searchPerformed,
    get_customer_list_pagination,
    selectedRow,
    handleChangeRowsPerPage,
    handleChangePage,
    rowsPerPage,
    page,
    newCustomer
  } = props;
 
 
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const parsed = dayjs(dateString, ['MM-DD-YYYY', 'YYYY-MM-DD']);
    return parsed.isValid() ? parsed.format("MM-DD-YYYY") : 'Invalid Date';
  };
 
 
  useEffect(() => {
    if (clientCustomerId && get_customer_list.length > 0) {
      const match = get_customer_list.find(c => c.id === clientCustomerId);
      if (match) {
        handleRowClick(clientCustomerId);
      }
    }
  }, [clientCustomerId, get_customer_list, handleRowClick]);
 
  const get_selected_customer =  useSelector((state) => state.task.clientCustomer || []);
 
  let finalCustomerList = [];
 
  if (newCustomer) {
    finalCustomerList = [newCustomer];
  } else if (get_customer_list && get_customer_list.length > 0) {
    finalCustomerList = get_customer_list;
  } else if (get_selected_customer && Object.keys(get_selected_customer).length > 0) {
    finalCustomerList = [get_selected_customer];
  }

const formatPhoneNumber = (phone) => {
  if (!phone) return '-';

  let digits = phone.replace(/\D/g, '');

  if (digits.length === 11 && digits.startsWith('1')) {
    digits = digits.slice(1);
  }

  if (digits.length === 10) {
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  }

  return phone;
};

 
  return (
  <Box sx={{ p: 0.5 }}>
    {searchPerformed && finalCustomerList.length > 0 ? (
      <>
        <Box sx={{ overflow: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th
                  style={{
                    padding: '12px 8px',
                    textAlign: 'left',
                    borderBottom: '2px solid #e0e0e0',                    
                    fontWeight: 600,
                  }}
                >
                  Name
                </th>
 
                <th
                  style={{
                    padding: '12px 8px',
                    textAlign: 'left',
                    borderBottom: '2px solid #e0e0e0',                    
                    fontWeight: 600,
                  }}
                >
                  Date of Birth
                </th>
 
                <th
                  style={{
                    padding: '12px 8px',
                    textAlign: 'left',
                    borderBottom: '2px solid #e0e0e0',                    
                    fontWeight: 600,
                  }}
                >
                  Active Policy
                </th>
 
                <th
                  style={{
                    padding: '12px 8px',
                    textAlign: 'left',
                    borderBottom: '2px solid #e0e0e0',                    
                    fontWeight: 600,
                  }}
                >
                  Location Name
                </th>
 
                <th
                  style={{
                    padding: '12px 8px',
                    textAlign: 'left',
                    borderBottom: '2px solid #e0e0e0',                    
                    fontWeight: 600,
                  }}
                >
                  Office Number
                </th>
              </tr>
            </thead>
            <tbody>
              {finalCustomerList.map((customer) => (
                <tr
                  key={customer.id}
                  onClick={() => handleRowClick(customer.id, customer)}
                  style={{
                    cursor: 'pointer',
                    backgroundColor:
                      selectedRow === customer.id
                        ? 'rgba(66, 133, 244, 0.08)'
                        : 'transparent',
                    transition: 'background-color 0.2s ease',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor =
                      selectedRow === customer.id
                        ? 'rgba(66, 133, 244, 0.15)'
                        : 'rgba(0, 0, 0, 0.04)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor =
                      selectedRow === customer.id
                        ? 'rgba(66, 133, 244, 0.08)'
                        : 'transparent';
                  }}
                >
                  <td
                    style={{
                      padding: '14px 8px',
                      borderBottom: '1px solid #e0e0e0',
                      fontWeight: selectedRow === customer.id ? 500 : 400,
                    }}
                  >
                    {customer?.firstName} {customer?.lastName}
                  </td>
 
                  <td
                    style={{
                      padding: '14px 8px',
                      borderBottom: '1px solid #e0e0e0',
                    }}
                  >
                    {formatDate(customer.dateOfBirth) || '-'}
                  </td>
 
                  <td
                    style={{
                      padding: '14px 8px',
                      borderBottom: '1px solid #e0e0e0',
                    }}
                  >
                    {customer.activePolicy === true ? 'Yes' : 'No'}
                  </td>
 
                  <td
                    style={{
                      padding: '14px 8px',
                      borderBottom: '1px solid #e0e0e0',
                    }}
                  >
                    {customer.locationAgencyName || '-'}
                  </td>
 
                  <td
                  style={{
                    padding: '14px 8px',
                    borderBottom: '1px solid #e0e0e0',
                    fontWeight: selectedRow === customer.id ? 500 : 400,
                  }}
                >
                  {formatPhoneNumber(customer.locationPhone)}
                </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Box>
 
        {!newCustomer && get_customer_list_pagination.totalElements > 0 && (
          <Box
            sx={{
              width: '100%',
              overflow: 'hidden',
              padding: '16px 0',
            }}
          >
            <Stack
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
              flexWrap="wrap"
              gap={2}
              sx={{
                '@media (max-width: 600px)': {
                  flexDirection: 'column',
                  alignItems: 'center',
                },
              }}
            > 
              <Box display="flex" alignItems="center">
                <Typography
                  variant="body2"
                  sx={{ fontSize: '12px', marginRight: '8px' }}
                >
                  Rows per page:
                </Typography>
                <Select
                  value={rowsPerPage}
                  onChange={handleChangeRowsPerPage}
                  size="small"
                  sx={{ fontSize: '12px', minWidth: '80px' }}
                >
                  {[5, 10, 15, 25, 50, 100].map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </Box>

              <Pagination
                count={get_customer_list_pagination.totalPages}
                page={page + 1}
                onChange={(event, value) => handleChangePage(event, value - 1)}
                showFirstButton
                showLastButton
                siblingCount={1}
                boundaryCount={1}
                size="small"
              />
            </Stack>
          </Box>
        )}
      </>
    ) : searchPerformed ? (
      <NoSearchResults />
    ) : null}
  </Box> 
);
};
 
 
export default CustomerSearchResultList;